import React, { FC } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { getExternalLinkRelAttribute } from '../../../utils/linkUtils';
import RoutableNotEditableLink from '../../@shared/routableNotEditableLink';
import { TModelsListingItemProps } from '../types/modelsListing.types';

const ModelsListItem: FC<TModelsListingItemProps> = ({ url, item }) => {
  return (
    // RoutableNotEditableLink is used, because the link is not editable
    <RoutableNotEditableLink href={url} className="models-listing__list-item" {...getExternalLinkRelAttribute(url)}>
      <img src={item.bigthumbnail} alt={item.bigthumbnailAlt || ''} className="models-listing__list-item__image" loading="lazy" />
      <div className="models-listing__list-item__details-wrapper">
        <RichText field={{ value: item.title }} tag="h3" className="models-listing__list-item__details-title" editable={false} />
        <RichText field={{ value: item.description }} tag="div" editable={false} className="rich-text" />
      </div>
    </RoutableNotEditableLink>
    // </RoutableSitecoreLink
  );
};

export default ModelsListItem;
